import React from "react";
import { getClientLogoUrl } from "../firebase/storage";

class ClientPicture extends React.Component {
  constructor(props) {
    super(props);
    this.state = { url: "", exists: true };
  }

  componentDidMount() {
    const { clientId, account } = this.props;
    if (clientId === undefined || clientId.length <= 0) {
      this.setState({ url: "", exists: false });
      return;
    }

    getClientLogoUrl(
      account.id,
      clientId,
      url => {
        this.setState({ url: url, exists: true });
      },
      error => {
        this.setState({ url: "", exists: false });
      }
    );
  }

  render() {
    const { url, exists } = this.state;
    const { small, big } = this.props;

    let size = "medium";
    if (small !== undefined) size = "small";
    if (big !== undefined) size = "big";

    if (exists) {
      if (url.length > 0) {
        //Es ist da!
        return (
          <img
            alt=""
            className="ClientPicture"
            type={size}
            src={url}
            style={{ objectFit: "cover" }}
          />
        );
      } else {
        //Unsicher / Lädt noch
        return (
          <div
            className="ClientPicture"
            type={size}
            style={{
              position: "relative",
              backgroundColor: "var(--color-white)"
            }}
          >
            <i
              className="fas fa-spinner"
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: "15px",
                textAlign: "center",
                animation: "a 2s infinite linear"
              }}
            />
          </div>
        );
      }
    } else {
      //Es gibt keins
      return (
        <img
          alt=""
          className="ClientPicture"
          type={size}
          style={{ backgroundColor: "var(--color-primary)" }}
        />
      );
    }
  }
}

export default ClientPicture;



// WEBPACK FOOTER //
// ./src/components/ClientPicture.js